<template>
  <section class="caseSearch">
    <header-com class='bgw'/>
    <!--搜索区-->
    <div class="search-wrap" :class='{clickSearch:clickSearch}'>
      <div class="search">
        <case-search-com ref="caseSearchCom" @getSearch='changeKey'/>
      </div>
      <div class="backBtn f28 grey9 t_right" @click="getSearch">确定</div>
    </div>

    <!--案例列表-->
    <ul class="" v-if="list.length > 0" class='list_content'>
      <li v-for="(item,index) in list" :key="index">
        <case-item-com :item="item" @changeZan='changeZan' :keyWords='keyWords'></case-item-com>
      </li>
    </ul>

    <!--历史记录-->
    <div class='historyTitle' v-if='historyList != 0 && list.length == 0 && historyList'>
      <div>历史记录</div>
      <img src='/images/case/delHis.png' class='delHis' @click='del_history'>
    </div>
    <ul class="historyList grey9" v-if='list.length == 0 && historyList != 0  && historyList'>
      <li v-for="(item,index) in historyList" :key="index" @click="hisSearch(item)">{{item}}</li>
    </ul>
    
  </section>
</template>

<script>
  import caseApi from '@/axios/case'
  import { Dialog } from 'vant';
  import zhugeObj from '@/assets/js/track';
  export default {
    name: 'caseSearch',
    data () {
      return {
        list: [],
        keyWords : '',
        historyList : [],
        clickSearch : false,
      }
    },
    watch: {},
    computed: {},
    created () {
      this._getHistory()
    },
    mounted () {
    },
    methods: {
      hisSearch(item){
        this.keyWords = item;
        this.$refs.caseSearchCom.keyWords = item;
        this.getSearch();
      },
      //删除历史品牌
      del_history(){
        let _this = this;
        Dialog.confirm({
          title: '提示',
          message: '是否确定删除？',
        }).then(() => {
          // on confirm
          localStorage.removeItem('historySearch');
          _this._getHistory();
        }).catch(() => {
          // on cancel
        });
        
      },
      _getHistory() {
        this.historyList = JSON.parse(localStorage.getItem('historySearch'));
        console.log(this.historyList)
      },
      //匹配是否已经存在历史记录
      historyMatch(history,str){
        let result = true;

        if(history && history.length > 0){
          history.forEach((item,index)=>{
            if(item.match(str)){
              result = false;
            }
          });
          if(result == false) return;
          history.push(str);
          if(history.length>10){
            history.shift();
          }

          localStorage.setItem('historySearch',JSON.stringify(history));
        }else{

          let data = [str];

          localStorage.setItem('historySearch',JSON.stringify(data));
        }
        this._getHistory();
      },
      changeKey(val){
        this.keyWords = val;
      },
      changeZan(item){
        this.list.forEach(element=>{
          if(element.id == item.id){
            if(element.zan){
              element.zanCount--;
            }else{
              element.zanCount++;
            }
            element.zan = !element.zan;
          }
        })
      },
      // 搜索
      getSearch () {
        if (this.keyWords) {
          let params = {
            keyWord : this.keyWords,
            current : 1,
            size : 10
          }
          caseApi.searchCase(params).then((res)=>{
            this.list = res.records;
            if(this.list.length != 0){
              this.clickSearch = true;
            }else{
              this.clickSearch = false;
            }
            let history = JSON.parse(localStorage.getItem('historySearch'));
            this.historyMatch(history,this.keyWords);

            zhugeObj.track({
              title : '案例库-搜索案例',
              content : {
                '搜索名称' : this.keyWords,
                '搜索结果' : this.list.length==0?'无结果':'成功'
              }
            })
          })

        } else {
          this.list = [];
          this.clickSearch = false;
        }
      }
    }

  }
</script>

<style lang="scss" scoped>
.clickSearch{
  top:0!important;
  z-index: 999!important;
  width: 85%!important;
  right: 0!important;
  left: auto!important;
  padding-top: 15px!important;
  .backBtn{
    top:25px!important;
  }
}
.bgw{
  background: #fff;
  z-index: 888;
}
.delHis{
  width: 29px;
  height: 30px;
}
.historyTitle{
  margin-top: 100px;
  padding: 0 0.4rem;
  font-size: 25px;
  margin-bottom: 25px;
  display: flex;
  justify-content: space-between;
  line-height: 30px;
}
.no-list{
  width:100%;
  margin-top: 0px;
}
  .list_content{
    // margin-top:50px;
  }
.caseSearch{
  padding: 122px 0 0;
  /*搜索区*/
  .search-wrap{
    transition: all 0.3s ease;
    width: 100%;
    box-sizing: border-box;
    padding: 30px;
    position:fixed;
    left: 0;
    top:70px;
    z-index: 20;
    display: flex;
    justify-content: space-between;
    .search{
      width: 100%;
    }
    .backBtn{
      width: 80px;
      line-height: 72px;
      position: absolute;
      top:32px;
      right:60px ;
    }
  }

  /*历史记录*/
  .historyList{
    display: flex;
    flex-wrap: wrap;
    padding: 0 30px;
    li{
      min-width: 156px;
      height: 54px;
      line-height: 52px;
      padding: 0 40px;
      box-sizing: border-box;
      border:1px solid #e9e9e9;
      margin:0 20px 30px 0;
      background: #f8f8f8;
      border-radius: 28px;
      text-align: center;
    }
  }
}
</style>
